module.exports = __webpack_public_path__ + "img/phone.29343afe.svg";